import * as React from 'react';
import { CDN_PREFIX } from './Const';
export var Icon = function Icon(props) {
  return React.createElement("img", {
    src: CDN_PREFIX + props.iconUrl
  });
};